import { BellIcon } from '@heroicons/react/24/outline'
import { BellIcon as BellIconSolid } from '@heroicons/react/24/solid'
import { ButtonHTMLAttributes, FC } from 'react'

import { useNotificationsCount } from '@/api/models/notifications/hooks/useNotificationsCount'
import { cn } from '@/app/utils'
import { ButtonSkeleton } from '@/components/shared/skeleton'

import NotificationUnreadCount from './NotificationUnreadCount/NotificationUnreadCount'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string
  active?: boolean
}

const NotificationButton: FC<Props> = ({ className, active, ...props }) => {
  const { data: unread, isLoading } = useNotificationsCount()

  if (isLoading) {
    return <ButtonSkeleton width={44} height={44} />
  }

  return (
    <button
      title="Открыть уведомления"
      className={cn(
        'group relative flex h-full items-center justify-center rounded-full bg-white p-10 transition-all hover:bg-bronze-40',
        'xs:p-6',
        active && 'bg-bronze-40',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'relative block h-24 w-24 group-hover:text-white/90 xs:h-20 xs:w-20',
          active && 'text-white/90'
        )}
      >
        <BellIcon
          className={cn(
            'absolute inset-0  transition-opacity',
            active && 'opacity-0'
          )}
        />
        <BellIconSolid
          className={cn(
            'absolute inset-0 opacity-0 transition-opacity',
            active && 'opacity-1'
          )}
        />
      </span>

      <NotificationUnreadCount
        unread={unread}
        variant="pinned"
        active={active}
      />
    </button>
  )
}

export default NotificationButton
